import React from "react";
function NavbarComponent() {
  return (
    <div className="w-100 justify-content-center header-div">
      <p className=" text-center">Welcome to Naveen's weather app</p>
    </div>
  );
}

export default NavbarComponent;
